export const FONTS = {
    primary: 'Mulish, sans-serif',
    secondary: 'Dancing Script, cursive'
}